@if (hasActionButtons()) {

    <app-button
        #mobileBtn
        [class.hidden]="!showElement()"
        [classList]="'opacity-0'"
        [type]="buttonType"
        [active]="service.active()"
        (event)="service.toggleButton()"
    >

        @if (service.active()) {
            <svg ngProjectAs="icon" class="text-current size-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 18 18 6M6 6l12 12"/>
            </svg>
        } @else {
            <svg ngProjectAs="icon" class="text-current size-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                <path d="M0.75 0.75H14.75"/>
                <path d="M0.75 5.75H14.75"/>
                <path d="M0.75 10.75H14.75"/>
            </svg>
        }

    </app-button>

}
